/*
 * Product page enhancements. Everything here is additive — the page is fully
 * usable with this file blocked:
 *
 *   - The cutoff line is server-rendered as a plain statement ("Orderstopp
 *     14:00 på vardagar"). Only when JS runs does it become a live countdown,
 *     because Shopify's CDN caches Liquid output and a clock rendered
 *     server-side would be stale for the next visitor.
 *   - The delivery estimate is appended for the same reason.
 *   - The volume-price row is highlighted as the quantity changes. Without JS
 *     the tiers still read as the price table they are.
 *   - The mobile gallery indicator follows native scroll-snap swipes and its
 *     labels smoothly scroll to a slide. Without JS the images are still
 *     swipeable; only the non-functional indicator is hidden.
 *
 * Desktop gallery switching, zoom, variant selection and add-to-cart are
 * deliberately NOT here: they work without JavaScript (see
 * sections/main-product.liquid).
 */
(function () {
  'use strict';

  var strings = window.themeStrings || {};

  function interpolate(template, values) {
    return Object.keys(values || {}).reduce(function (text, key) {
      return text.split('{' + key + '}').join(String(values[key]));
    }, template || '');
  }

  var DAYS = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
  var MONTHS = [
    'januari',
    'februari',
    'mars',
    'april',
    'maj',
    'juni',
    'juli',
    'augusti',
    'september',
    'oktober',
    'november',
    'december',
  ];

  var cutoffEl = document.querySelector('[data-cutoff]');
  var deliveryEl = document.querySelector('[data-delivery-date]');
  var qtyInput = document.getElementById('pdp-qty');
  var tierRows = Array.prototype.slice.call(document.querySelectorAll('[data-tier-min]'));

  /* Serverns egna texter, fångade före första omskrivningen. Båda måste kunna
     backas: en flik som står öppen över orderstoppet ska falla tillbaka till
     "Orderstopp 14:00 …" och inte frysa på nedräkningens sista värde. */
  var cutoffBase = cutoffEl ? cutoffEl.textContent.trim() : '';
  var deliveryBase = deliveryEl ? deliveryEl.textContent.trim() : '';

  /*
   * Butiken är svensk och orderstoppet är svensk tid. `new Date()` läser
   * BESÖKARENS klocka och tidszon — en kund med datorn i UTC ligger en timme
   * fel på vintern och två på sommaren, och kan dessutom stå på en annan
   * veckodag, vilket flyttar hela beräkningen.
   *
   * Delarna hämtas därför i Europe/Stockholm och sätts ihop igen via Date.UTC.
   * Objektet pekar på fel tidpunkt i absolut mening, men dess getUTC*-fält ÄR
   * den svenska väggklockan — och det är allt räkningen nedan använder. Därav
   * getUTC-varianterna rakt igenom.
   *
   * Saknas Intl, eller känner webbläsaren inte till tidszonen, blir svaret
   * null och sidan behåller serverns bastexter. Hellre den generella
   * formuleringen än ett datum som är fel.
   */
  var swedishClock = (function () {
    try {
      var formatter = new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Stockholm',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });
      return typeof formatter.formatToParts === 'function' ? formatter : null;
    } catch (error) {
      return null;
    }
  })();

  function swedishNow() {
    if (!swedishClock) return null;

    var parts = {};
    swedishClock.formatToParts(new Date()).forEach(function (part) {
      parts[part.type] = part.value;
    });

    var year = parseInt(parts.year, 10);
    var month = parseInt(parts.month, 10);
    var day = parseInt(parts.day, 10);
    var hour = parseInt(parts.hour, 10);
    var minute = parseInt(parts.minute, 10);
    var second = parseInt(parts.second, 10);

    if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hour) || isNaN(minute)) return null;
    /* Midnatt skrivs som 24 av äldre ICU-versioner. */
    if (hour === 24) hour = 0;

    return new Date(Date.UTC(year, month - 1, day, hour, minute, isNaN(second) ? 0 : second));
  }

  function isWeekday(date) {
    var day = date.getUTCDay();
    return day >= 1 && day <= 5;
  }

  /* Advances `count` business days from `from`, skipping Saturdays and
     Sundays. Public holidays are not modelled — the shop has no calendar for
     them, and overpromising by a day is worse than the generic fallback. */
  function addBusinessDays(from, count) {
    var date = new Date(from.getTime());
    var added = 0;
    while (added < count) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (isWeekday(date)) added += 1;
    }
    return date;
  }

  /* The cutoff line and the delivery line are two independent theme settings —
     clearing one must not silence the other, so neither element gates the
     function as a whole. The cutoff hour is read from whichever is present. */
  function cutoffHour() {
    var source = cutoffEl || deliveryEl;
    if (!source) return NaN;
    return parseInt(source.getAttribute('data-cutoff-hour'), 10);
  }

  function updateDelivery() {
    var hour = cutoffHour();
    if (isNaN(hour)) return;

    var now = swedishNow();
    if (!now) return;

    var cutoff = new Date(now.getTime());
    cutoff.setUTCHours(hour, 0, 0, 0);

    var shipsToday = isWeekday(now) && now < cutoff;

    if (cutoffEl) {
      if (shipsToday) {
        var remaining = cutoff - now;
        var hours = Math.floor(remaining / 3600000);
        var minutes = Math.floor((remaining % 3600000) / 60000);
        var within = hours > 0 ? hours + ' h ' + minutes + ' min' : minutes + ' min';
        cutoffEl.textContent = 'Beställ inom ' + within + ' — skickas idag';
      } else if (cutoffBase) {
        /* Orderstoppet har passerat, eller det är helg. Utan den här grenen
           stod nedräkningen kvar på "Beställ inom 0 min — skickas idag" resten
           av kvällen och lovade samma dag åt en kund som beställde 15:20. */
        cutoffEl.textContent = cutoffBase;
      }
    }

    if (deliveryEl) {
      var leadDays = parseInt(deliveryEl.getAttribute('data-lead-days'), 10) || 1;
      var shipDay = shipsToday ? now : addBusinessDays(now, 1);
      var arrival = addBusinessDays(shipDay, leadDays);
      var eta = 'Hos er ' + DAYS[arrival.getUTCDay()] + ' ' + arrival.getUTCDate() + ' ' + MONTHS[arrival.getUTCMonth()];
      deliveryEl.textContent = deliveryBase ? deliveryBase + ' ' + eta : eta;
    }
  }

  function updateTiers() {
    if (!qtyInput || tierRows.length === 0) return;

    var quantity = parseInt(qtyInput.value, 10) || 1;
    var activeIndex = -1;

    tierRows.forEach(function (row, index) {
      var minimum = parseInt(row.getAttribute('data-tier-min'), 10);
      if (!isNaN(minimum) && quantity >= minimum) activeIndex = index;
    });

    tierRows.forEach(function (row, index) {
      row.classList.toggle('pdp-tiers__row--active', index === activeIndex);
    });
  }

  /*
   * Keeps the "N i kundvagnen" line honest after an AJAX add. cart.js emits
   * cart:updated with the cart as the server now has it; this counts only the
   * lines for the variant this page is showing.
   */
  function updateInCart(cart) {
    var el = document.querySelector('[data-in-cart]');
    if (!el || !cart || !cart.items) return;

    var variantId = el.getAttribute('data-variant-id');
    var quantity = cart.items.reduce(function (sum, item) {
      return String(item.variant_id) === variantId ? sum + item.quantity : sum;
    }, 0);

    el.textContent = interpolate(strings.inCartCount || '{count} i kundvagnen', { count: quantity });
    el.hidden = quantity === 0;
  }

  /*
   * The zoom overlay is pure :target CSS and needs no JavaScript to open. What
   * it cannot do on its own is stop the page behind it from being tabbed
   * through while it covers the screen. When JS is available we give it the
   * same treatment the cart drawer gets: focus moves in, Tab is trapped, Escape
   * closes. Without JS the overlay still opens and closes by link.
   */
  function zoomTrap(event) {
    var open = document.querySelector('.pdp-zoom:target');
    if (!open) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      window.location.hash = '#pdp-galleri';
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(open.querySelectorAll('a[href]'));
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function focusZoom() {
    var open = document.querySelector('.pdp-zoom:target');
    if (!open) return;
    var close = open.querySelector('.pdp-zoom__close');
    if (close) close.focus();
  }

  /* A minute's resolution is what the countdown shows; 30s keeps it from
     lagging a full minute behind — but only while someone is looking at it.
     En dold flik räknar ner för ingen, och en produktsida som ligger öppen en
     arbetsdag hinner med tusen sådana anrop. */
  var deliveryTimer = null;

  function syncDeliveryTimer() {
    if (document.hidden) {
      window.clearInterval(deliveryTimer);
      deliveryTimer = null;
      return;
    }
    /* Texten är gammal när fliken kommer tillbaka — räkna om direkt, inte om
       trettio sekunder. */
    updateDelivery();
    if (!deliveryTimer) deliveryTimer = window.setInterval(updateDelivery, 30000);
  }

  /* Går den svenska klockan inte att läsa startas ingen timer alls — då hade
     den bara räknat tomvarv, och serverns bastexter står redan i sidan. */
  if ((cutoffEl || deliveryEl) && swedishNow()) {
    syncDeliveryTimer();
    document.addEventListener('visibilitychange', syncDeliveryTimer);
  }

  document.addEventListener('cart:updated', function (event) {
    updateInCart(event.detail);
  });

  if (document.querySelector('.pdp-zoom')) {
    document.addEventListener('keydown', zoomTrap, true);
    window.addEventListener('hashchange', focusZoom);
  }

  if (qtyInput && tierRows.length > 0) {
    updateTiers();
    qtyInput.addEventListener('input', updateTiers);
    /* The stepper buttons set input.value directly (see cart.js), which fires
       no input event — so re-check after any click in the stepper. */
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-qty-stepper]')) updateTiers();
    });
  }

  /* Mobile product gallery. CSS turns the stage into a native scroll-snap
     strip below 600px, so touch scrolling works before this file loads and
     even if it is blocked. JavaScript owns only the two-way synchronisation:
     swipe -> checked dot, and dot/keyboard -> smooth scroll.

     A passive scroll listener plus requestAnimationFrame avoids layout work
     more than once per painted frame. Shots are all exactly one stage wide,
     but offsetLeft is used instead of index * width so the calculation stays
     correct if the gallery ever gains a gap. */
  var galleryStage = document.querySelector('[data-gallery-stage]');
  var galleryShots = galleryStage
    ? Array.prototype.slice.call(galleryStage.querySelectorAll('[data-gallery-shot]'))
    : [];
  var galleryRadios = Array.prototype.slice.call(document.querySelectorAll('.pdp-gallery__radio'));
  var mobileGallery = window.matchMedia('(max-width: 600px)');

  if (galleryStage && galleryShots.length > 1 && galleryRadios.length === galleryShots.length) {
    var galleryQueued = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    var nearestGalleryIndex = function () {
      var nearest = 0;
      var distance = Infinity;

      galleryShots.forEach(function (shot, index) {
        var nextDistance = Math.abs(shot.offsetLeft - galleryStage.scrollLeft);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });

      return nearest;
    };

    var syncGalleryIndicator = function () {
      galleryQueued = false;
      if (!mobileGallery.matches) return;

      var activeRadio = galleryRadios[nearestGalleryIndex()];
      if (activeRadio && !activeRadio.checked) activeRadio.checked = true;
    };

    var queueGallerySync = function () {
      if (galleryQueued || !mobileGallery.matches) return;
      galleryQueued = true;
      requestAnimationFrame(syncGalleryIndicator);
    };

    var scrollToCheckedGalleryShot = function (behavior) {
      if (!mobileGallery.matches) return;

      var checkedIndex = galleryRadios.findIndex(function (radio) {
        return radio.checked;
      });
      var shot = galleryShots[checkedIndex < 0 ? 0 : checkedIndex];
      if (!shot) return;

      galleryStage.scrollTo({ left: shot.offsetLeft, behavior: behavior });
    };

    galleryRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        scrollToCheckedGalleryShot(reducedMotion.matches ? 'auto' : 'smooth');
      });
    });

    var handleGalleryMode = function () {
      if (mobileGallery.matches) scrollToCheckedGalleryShot('auto');
    };

    galleryStage.addEventListener('scroll', queueGallerySync, { passive: true });
    if (typeof mobileGallery.addEventListener === 'function') {
      mobileGallery.addEventListener('change', handleGalleryMode);
    } else {
      mobileGallery.addListener(handleGalleryMode);
    }
    handleGalleryMode();
  }

  /* Fasta köpraden på mobil. Visas först när det riktiga köpblocket skrollat
     förbi — annars konkurrerar två identiska knappar om samma klick. Raden
     ligger `hidden` i markupen, så utan JavaScript finns den inte alls.

     Varför inte IntersectionObserver: den fyrar bara när ett tröskelvärde
     KORSAS. Hoppar sidan förbi köpblocket i ett steg — ankarlänk, tillbaka-
     navigering som återställer skrollpositionen, "hoppa till specifikation" —
     går elementet från "under vyn, ej synligt" till "ovanför vyn, ej synligt"
     utan att något tröskelvärde korsas, och callbacken kallas aldrig. Raden
     uteblev då helt. Verifierat: en observer på köpblocket loggade en enda
     gång, vid registreringen.

     Lyssnaren är därför en vanlig scroll, men passiv och rAF-grindad: högst
     en läsning per bildruta, och den läser bara ett getBoundingClientRect. */
  var stickyBar = document.querySelector('[data-pdp-sticky]');
  var buyForm = document.querySelector('.pdp-buy__form');

  if (stickyBar && buyForm) {
    var stickyQueued = false;

    var syncSticky = function () {
      stickyQueued = false;
      var stickyVisible = buyForm.getBoundingClientRect().bottom <= 0;
      stickyBar.classList.toggle('pdp-sticky--visible', stickyVisible);
      stickyBar.setAttribute('aria-hidden', stickyVisible ? 'false' : 'true');
    };

    var queueSticky = function () {
      if (stickyQueued) return;
      stickyQueued = true;
      requestAnimationFrame(syncSticky);
    };

    /* `hidden` is the no-JS fallback. Once scripting is active the element
       stays rendered just below the viewport so CSS can animate both ways. */
    stickyBar.hidden = false;
    syncSticky();
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky, { passive: true });
  }

  /* Lagerbevakning. Adressen går till hjartgruppen-automations
     (api/stock-watch.js), som lägger en rad i `stock_watch`; cron-jobbet
     `stock-notify` mejlar av sig själv när varianten är säljbar igen.

     Till 2026-08-07 var rutan ett Shopify-kontaktformulär som mejlade butiken,
     och utskicket till kunden var alltså handarbete som aldrig blev av.

     Kroppen är formulärkodad och inte JSON. Det gör anropet till en "simple
     request" som slipper CORS-preflight — annars hade varje anmälan kostat en
     extra tur över Atlanten innan kunden fick sitt kvitto. */
  var watchForm = document.querySelector('[data-stock-watch]');

  if (watchForm) {
    var watchButton = watchForm.querySelector('[data-stock-watch-submit]');
    var watchStatus = watchForm.querySelector('[data-stock-watch-status]');
    var watchRow = watchForm.querySelector('[data-stock-watch-row]');
    var watchLede = watchForm.querySelector('[data-stock-watch-lede]');
    var watchEmail = watchForm.querySelector('input[type="email"]');
    // Butikens egen adress — temat delas av flera butiker och felmeddelandet
    // fick inte skicka Medstuffs kunder till Hjärtgruppens inkorg.
    var watchContact = watchForm.getAttribute('data-contact-email');
    var watchFailText = watchContact
      ? interpolate(strings.stockFailEmail || 'Det gick inte just nu. Mejla {email} så ordnar vi det.', { email: watchContact })
      : strings.genericError || 'Det gick inte just nu. Försök igen om en stund.';
    var watchBusy = false;

    /* Knappen ligger avstängd i markupen. Är den fortfarande det står sidan
       utan JS, och noscript-raden med mejladressen är enda vägen vidare. */
    if (watchButton) watchButton.disabled = false;

    var showStatus = function (message, isError) {
      if (!watchStatus) return;
      watchStatus.textContent = message;
      watchStatus.hidden = false;
      watchStatus.classList.toggle('pdp-notify__ok--error', Boolean(isError));
    };

    /* Kvittot ersätter fältet — står formuläret kvar ser det ut som att
       anmälan inte gick igenom, och adressen skickas en gång till. */
    var closeForm = function (message) {
      if (watchRow) watchRow.hidden = true;
      if (watchLede) watchLede.hidden = true;
      showStatus(message, false);
    };

    watchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (watchBusy) return;

      var endpoint = watchForm.getAttribute('data-endpoint');
      var variant = watchForm.getAttribute('data-variant');
      var email = watchEmail ? watchEmail.value.trim() : '';

      if (!endpoint || !variant || !email) return;

      watchBusy = true;
      if (watchButton) watchButton.disabled = true;
      showStatus(strings.sending || 'Skickar …', false);

      var body = new URLSearchParams();
      body.set('email', email);
      body.set('variant', variant);
      body.set('foretag', watchForm.foretag ? watchForm.foretag.value : '');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .then(function (response) {
          return response.json().catch(function () {
            return { ok: false, error: 'server' };
          });
        })
        .then(function (data) {
          if (data && data.ok && data.status === 'in_stock') {
            /* Sidan är cachad av Shopifys CDN och kan vara minuter gammal —
               varan hann komma in medan besökaren läste. */
            closeForm(strings.stockInStock || 'Varan finns redan i lager igen — ladda om sidan så syns köpknappen.');
            return;
          }

          if (data && data.ok) {
            closeForm(
              data.status === 'already'
                ? strings.stockAlready || 'Du bevakar redan varan — vi mejlar när den är inne igen.'
                : strings.stockSuccess || 'Klart. Vi mejlar automatiskt när varan är inne igen.'
            );
            return;
          }

          var reason = data && data.error;
          if (reason === 'email') {
            showStatus(strings.emailError || 'Kontrollera adressen och försök igen.', true);
          } else if (reason === 'rate') {
            showStatus(strings.rateLimitError || 'För många anmälningar just nu. Försök igen om en stund.', true);
          } else {
            showStatus(watchFailText, true);
          }

          watchBusy = false;
          if (watchButton) watchButton.disabled = false;
        })
        .catch(function () {
          showStatus(watchFailText, true);
          watchBusy = false;
          if (watchButton) watchButton.disabled = false;
        });
    });
  }
})();
